export const primaryIntervals = [
  {
    ref: "past_hour",
    milliseconds: 3_600_000,
    granularity: "1h",
  },
  {
    ref: "past_6_hours",
    milliseconds: 21_600_000,
    granularity: "1h",
  },
  {
    ref: "past_12_hours",
    milliseconds: 43_200_000,
    granularity: "1h",
  },
  {
    ref: "past_24_hours",
    milliseconds: 86_400_000,
    granularity: "1h",
  },
  {
    ref: "past_7_days",
    milliseconds: 604_800_000,
    granularity: "1h",
  },
  {
    ref: "past_30_days",
    milliseconds: 2_592_000_000,
    granularity: "1h",
  },
] as const;

export type IntervalRefs = (typeof primaryIntervals)[number]["ref"];

/**
 * Ranges used for polling queries fall into two categories
 *
 * - X hours ago - start time is based on the current time and will change between polls
 * - X days ago - start time is midnight and will not change between polls
 *
 * When the polling interval is reached e.g. every 5 minutes a new timestamp is calculated for the query.
 * For day ranges the timestamp will not change and the API may not be called. (It will need to be refetched)
 * For hour queries refetched is not appropriate as the start time has changed.
 * @param ref
 */
export const isDayInterval = (ref: IntervalRefs) => {
  return ["past_7_days", "past_30_days"].includes(ref);
};
